export default {
	data() {
		return {
			modalId: ''
		}
	},
	methods: {
		OpenModal() {
			const modal = window.jQuery(this.modalId)
			modal.modal({
				focus: false,
			})
			modal.modal('show')
		},
		CloseModal() {
			window.jQuery(this.modalId).modal('hide')
			window.jQuery('body').removeClass('modal-open')

			this.$emit('close')
		},
	},
	mounted() {
		window
			.jQuery(this.modalId)
			.on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')

				this.$emit('close')
			})
	}
}